import { render, staticRenderFns } from "./MailserviceSettingForm.vue?vue&type=template&id=5c9b3ae7&scoped=true"
import script from "./MailserviceSettingForm.vue?vue&type=script&lang=js"
export * from "./MailserviceSettingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b3ae7",
  null
  
)

export default component.exports